import { render, staticRenderFns } from "./client-chart.vue?vue&type=template&id=926c6c7c"
import script from "./client-chart.vue?vue&type=script&lang=js"
export * from "./client-chart.vue?vue&type=script&lang=js"
import style0 from "./client-chart.vue?vue&type=style&index=0&id=926c6c7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports